import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as packageInfo from 'package.json'

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public appVersion:string
  public lastUpdated: string

  constructor() {
    this.appVersion = packageInfo.version
    this.lastUpdated = environment.lastUpdated
  }

  ngOnInit() {
  }

}
